import { isAuthor } from './utils';

var last = function last(arr) {
  return arr[arr.length - 1];
};

var dateChanged = function dateChanged(curr, prev) {
  return curr && prev && (prev.getDate() !== curr.getDate() || prev.getMonth() !== curr.getMonth() || prev.getFullYear() !== curr.getFullYear());
};

var addDateMarker = function addDateMarker(acc, msg) {
  var timestamp = msg.timestamp;
  var lastItem = last(acc);

  if (!timestamp) {
    return;
  }

  if (!lastItem || dateChanged(timestamp, lastItem.timestamp)) {
    var dateMarker = {
      type: 'date-marker',
      timestamp: timestamp,
      trackBy: timestamp.getTime()
    };
    acc.push(dateMarker);
  }
};

var groupMessages = function groupMessages(acc, msg, isLastMessage) {
  var lastItem = last(acc);
  var messages = undefined;

  if (msg.typing && !isLastMessage) {
    return;
  }

  if (lastItem && lastItem.type === 'message-group') {
    messages = lastItem.messages;
  }

  if (messages && isAuthor(msg.author, last(messages))) {
    messages.push(msg);
  } else {
    acc.push({
      type: 'message-group',
      messages: [msg],
      author: msg.author,
      timestamp: msg.timestamp,
      trackBy: msg
    });
  }
};

var groupItems = function groupItems(total) {
  return function (acc, msg, index) {
    var isLastMessage = index === total - 1;
    addDateMarker(acc, msg);
    groupMessages(acc, msg, isLastMessage);

    if (msg.attachments && msg.attachments.length > 1) {
      acc.push({
        type: 'attachment-group',
        attachments: msg.attachments,
        attachmentLayout: msg.attachmentLayout,
        timestamp: msg.timestamp,
        trackBy: msg
      });
    }

    if (msg.suggestedActions && isLastMessage) {
      acc.push({
        type: 'action-group',
        actions: msg.suggestedActions,
        timestamp: msg.timestamp,
        trackBy: msg
      });
    }

    return acc;
  };
};

function assignSelectionIndices(viewItems) {
  var selectionCounter = 0;
  viewItems.forEach(function (viewItem) {
    if (viewItem.type === 'message-group') {
      viewItem.messages.forEach(function (msg) {
        msg.selectionIndex = selectionCounter++;
      });
    } else if (viewItem.type === 'attachment-group' || viewItem.type === 'action-group') {
      viewItem.selectionIndex = selectionCounter++;
    }
  });
  viewItems.lastSelectionIndex = selectionCounter - 1;
}
/**
 * @hidden
 */


export var convertMsgsToViewItems = function convertMsgsToViewItems(messages) {
  var result = messages.reduce(groupItems(messages.length), []);
  assignSelectionIndices(result);
  return result;
};